.root {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 0.938rem;
  line-height: 1.25rem;
  font-weight: 400;

  @media screen and (min-width: 1040px) {
    font-size: 0.875rem;
  }
}

.asOfLastCloseLabel {
  font-size: 0.938rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: var(--text-soft);

  @media screen and (min-width: 1040px) {
    font-size: 0.875rem;
  }
}

.marketOpenWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.35em;
}

.marketSessionActive {
  color: var(--viz-bullish);
}
